import instagramIcon from "~/img/instagram.svg?no-inline";

const Intro = ({ children }: { children: React.ReactNode }) => (
  <header
    style={{
      fontSize: "18px",
      fontWeight: 300,
      margin: "30px auto",
      textAlign: "center",
    }}
  >
    {children}
  </header>
);

const Title = ({ children }: { children: React.ReactNode }) => (
  <div
    style={{
      display: "inline",
      lineHeight: "30px",
      verticalAlign: "middle",
    }}
  >
    {children}
  </div>
);

const Instagram = ({
  children,
  ...props
}: React.AnchorHTMLAttributes<HTMLAnchorElement>) => (
  <a
    {...props}
    style={{
      borderRadius: "25%",
      boxShadow: "none",
      display: "inline-block",
      margin: "-3px 0 0 10px",
      // TODO, eg. with CSS-in-JS
      // '&:hover, &:focus': {
      //   backgroundColor: 'var(--yellow)',
      //   boxShadow: 'none',
      // },
    }}
  >
    {children}
  </a>
);

export const Header = () => {
  return (
    <Intro>
      <Title>
        This is just a blog about{" "}
        <a
          href="https://kylorhall.com/"
          target="_blank"
          rel="noreferrer noopener"
          title="Kylor Hall's personal website"
        >
          my
        </a>{" "}
        daily coffee.
      </Title>

      <Instagram
        href="https://www.instagram.com/kylorhall/"
        target="_blank"
        rel="noreferrer noopener"
        title="Feel free to follow me on Instagram"
      >
        <img
          src={instagramIcon}
          style={{
            display: "inline-block",
            verticalAlign: "middle",
            aspectRatio: "1 / 1",
          }}
          role="img"
          aria-label="Instagram Logo"
        />
      </Instagram>
    </Intro>
  );
};
